// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hBiNQ","importantInfo":"styles_importantInfo__3xlie"};